<template>
  <button
    type="button"
    class="flsa-determination-card"
    :class="{ 'flsa-determination-card-selected': selected }"
    @click="$emit('click')"
  >
    <span class="text-h2 text-textDark flsa-determination-card-title">{{ label }}</span>
    <span class="text-body-2 text-textLight flsa-determination-card-body">{{ sublabel }}</span>
  </button>
</template>

<script setup>
defineProps({
  label: {
    type: String,
    required: true,
  },
  sublabel: {
    type: String,
    required: true,
  },
  selected: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['click']);
</script>

<style scoped lang="less">
.flsa-determination-card {
  background: @white;
  border: 2px solid @stroke-default;
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 4px;
  height: 76px;
  justify-content: center;
  padding: 16px;
  text-align: left;
}

.flsa-determination-card-selected {
  background: @indigo-100;
  border-color: @indigo-500;

  .flsa-determination-card-title {
    color: @indigo-700 !important;
  }

  .flsa-determination-card-body {
    color: @indigo-500 !important;
  }
}
</style>
